import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

export default function ExplanationDialog(props) {
	const handleClose = () => {
		props.setOpen(false);
	};

	return (
		<div>
			<Dialog open={props.open} maxWidth={false} onClose={handleClose}>
				<DialogTitle textAlign={"center"}>Grades Finalized - SPOT Report Release</DialogTitle>

				<div className="flex flex-col gap-4 w-[80dvw] px-4 ">
					<p>
						SPOT survey results cannot be shared with instructors until grades for all students in
						their class have been approved and finalized. In the past, it has been a manual process
						to determine the grade finalization status for each class.
					</p>
					<p>
						We are happy to announce that we have created an automated process to inform our data of
						grade finalization statuses, from Winter 2026 onward.
					</p>
					<p>
						Starting this term, our regular class data imports will pull in the most recent grade
						finalization statuses for all classes, and we will use this data to automatically
						release SPOT survey results to instructors. The process is not yet fully automated (TBD
						if it ever will be, we would like to hear your feedback), but it will be as follows for
						all departments that are <span className="font-semibold">opted IN</span> (default):
					</p>
					<ol className="list-decimal list-inside pl-4">
						<li>
							SPOT survey concludes, results imported into reporting system (manual - done by TSQS)
						</li>
						<li>
							Class data update - Finalized courses set from latest data (
							<span className="font-semibold text-primary">opted IN = automatic</span>,{" "}
							<span className="font-semibold text-red-600">opted OUT = manual - done by you</span>)
						</li>
						<li>
							TSQS periodically sends manual report access email to 'ready' courses(manual - done by
							TSQS)
						</li>
					</ol>
					<p>
						<span className="underline">
							Reports will only be released to instructors if a class has a{" "}
							<span className="font-semibold">100% grade finalization</span> status.
						</span>{" "}
						Importantly, this means that if there is a delay in grade finalization for a class
						because of something like a single student's grade dispute, SPOT results will be
						withheld from that instructor until that student's grade is resolved. For this reason,
						you will retain the ability to manually release SPOT results to instructors if you wish
						to do so. That is the purpose of this screen.
					</p>
					<p>
						Confirmation can be un-done until the results email has been sent to the instructor(s)
						for the course. After which point, the option to reverse a confirmation will be
						disabled.
					</p>

					<p>
						By default, all departments have been "opted in" to the new automated method of
						confirming grade finalization statuses.{" "}
						<span className="font-semibold underline">
							If you have a specific need to want to retain FULL manual control over the grade
							finalization status for your department (and by extension, the release of SPOT results
							to your instructors), please contact TSQS and we will disable this automation for you.
						</span>
					</p>

					<p className="underline">
						This is a setting that will apply to your entire department, so please ensure that you
						are on the same page as your colleagues before proceeding.
					</p>
				</div>

				<DialogActions>
					<Button onClick={handleClose}>OK</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
